<template>
  <div class="cons">
    <div class="cons-card">
      <div class="cons-video">
        <div class="cons-videos">
          <div v-for="frame in frames"
            :key="frame.stream.streamId" class="co" :class="'co-' + frames.length">
            <Video v-if="frame.streamManager"
              :frame="frame"
              :self="false"
            />
          </div>
        </div>
        <div class="video-bottom">
          <button @click="back">
            <i class="material-icons">arrow_back</i>
          </button>
          <button @click="toggleAudio">
            <i v-if="audio" class="material-icons">mic</i>
            <i v-else class="material-icons red">mic_off</i>
          </button>
          <button @click="toggleVideo">
            <i v-if="video" class="material-icons">videocam</i>
            <i v-else class="material-icons red">videocam_off</i>
          </button>
          <button class="chat" @click="showChat = true">
            <i class="material-icons">chat</i>
          </button>
        </div>
      </div>
      <div class="cons-chat" :class="{ 'show': showChat }">
        <div class="chat-title" v-if="fullName">
          <div class="info">
            <div class="avatar">
              <div v-if="avatar" :style="{ backgroundImage: `url(${avatar})`}"></div>
              <div v-else>{{ initials }}</div>
            </div>
            <div>
              <div class="name">{{ fullName }}</div>
              <div class="specialty">{{ specialty }}</div>
            </div>
          </div>
          <div class="time">
            <div class="start"><span class="prefix">Начало:</span>{{ startTime }}</div>
            <div class="end"><span class="prefix">Конец:</span>{{ endTime }}</div>
          </div>
        </div>
        <div class="chat-viewer" ref="chatView">
          <div v-for="log in messages" :key="log.uuid">
            <div v-if="log.dayTitle" class="chat-date">{{ log.dayTitle }}</div>
            <div class="chat-message">
              <div class="avatar" v-if="!log.collapsed">
                <div v-if="log.avatar" :style="{ backgroundImage: `url(${log.avatar})`}"></div>
                <div v-if="!log.avatar">{{ log.initials }}</div>
              </div>
              <div v-else class="face-avatar"></div>
              <div class="content">
                <div class="title" v-if="!log.collapsed">{{ log.user }}</div>
                <div v-if="log.text" class="text">{{ log.text }}</div>
                <div v-if="log.file && log.file.type === 'file'" class="file">
                  <div class="download-icon">
                    <i class="material-icons">arrow_downward</i>
                  </div>
                  <div class="info">
                    <div class="info-title">{{ log.file.name }}</div>
                    <button @click="download(log.file.data)">Загрузить</button>
                  </div>
                </div>
                <div v-if="log.file && log.file.type === 'image'" class="image">
                  <a :href="log.file.data" target="_blank">
                    <img :src="log.file.data" alt="image" />
                  </a>
                </div>
              </div>
              <div class="chat-time">{{ log.time }}</div>
            </div>
          </div>
        </div>
        <div class="chat-enter">
          <div class="chat-action">
            <button class="voice-chat" @click="showChat = false">
              <i class="material-icons">voice_chat</i>
            </button>
            <label class="chat-attachment" v-b-tooltip.hover title="прикрепить файл">
              <input
                type="file"
                @change="selectFiles"
                id="attach-files"
                class="upload-button"
                multiple
              />
              <i class="material-icons">attach_file</i>
            </label>
          </div>
          <div class="chat-input">
            <div class="chat-textarea-wrap">
              <ResizeAuto>
                <textarea
                  id="enter"
                  placeholder="Введите сообщение..."
                  class="textarea"
                  rows="1"
                  @keydown.enter.exact.prevent="sendMessage"
                ></textarea>
              </ResizeAuto>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import ResizeAuto from './ResizeAuto';
import Video from './Video';
import { patientApi } from '@app/services';

export default {
  components: {
    ResizeAuto,
    Video,
  },
  data: () => ({
    stream: null,
    streamManager: null,
    logs: [],
    audio: true,
    video: true,
    count: 0,
    isBottom: true,
    showChat: false,
    avatar: null,
    fullName: null,
    initials: null,
    specialty: null,
    startTime: null,
    endTime: null,
  }),
  computed: {
    name() {
      return this.$store.state.chat.name;
    },
    messages() {
      return this.$store.getters['chat/chat'];
    },
    frames() {
      return this.$store.getters['chat/frames'];
    },
    userFrame() {
      return this.$store.state.chat.userFrame;
    }
  },
  watch: {
    messages(newState, oldState) {
      if (this.isBottom) {
        this.scrollToEnd();
      } else if (newState.length > oldState.length) {
        this.count++;
      }
    }
  },
  async created() {
    moment.locale('ru');
    await this.$store.dispatch('chat/joinConversation', this.$route.params.id);
    await this.scrollToEnd();
    await this.$store.dispatch('chat/startStreaming');
    const { items } = await patientApi.getSlots({}, true);
    const item = items.find(({ conversation }) => conversation && conversation.id && conversation.id === this.$route.params.id);
    if (item) {
      const firstName = item.doctor.employee.first_name;
      const middleName = item.doctor.employee.middle_name;
      const lastName = item.doctor.employee.last_name;
      this.fullName = firstName + ' ' + (middleName ? middleName : lastName);
      this.initials = firstName.charAt(0) + (middleName ? middleName : lastName).charAt(0);
      this.avatar = item.doctor.employee.avatar;
      this.specialty = item.doctor.specialty.title;
      this.startTime = item.start_time.substring(11).substring(0, 5);
      this.endTime = item.end_time.substring(11).substring(0, 5);
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    async readFile(file) {
      const reader = new FileReader();
      return new Promise(resolve => {
        reader.onload = ({ target }) => resolve(target.result);
        reader.readAsDataURL(file);
      });
    },
    async selectFiles({ target }) {
      const { firstName, lastName, userId } = this.$store.state.permission;
      const user = {
        user: `${firstName} ${lastName}`,
        userId
      };
      const conversationId = this.$route.params.id;
      const files = [];
      for (var i = 0; i < target.files.length; i++) {
        const targetFile = target.files.item(i);
        if (targetFile.type.substring(0, 5) === 'image') {
          const data = await this.readFile(targetFile);
          files.push({
            targetFile,
            source: 'base64',
            type: 'image',
            data
          });
        } else {
          files.push({
            targetFile,
            source: 'base64',
            type: 'file',
            name: targetFile.name
          });
        }
      }
      await this.$store.dispatch('chat/sendFiles', { conversationId, user, files });
    },
    toggleAudio() {
      if (this.audio) {
        this.$store.dispatch('chat/disableAudio');
      } else {
        this.$store.dispatch('chat/enableAudio');
      }
      this.audio = !this.audio;
    },
    toggleVideo() {
      if (this.video) {
        this.$store.dispatch('chat/disableVideo');
      } else {
        this.$store.dispatch('chat/enableVideo');
      }
      this.video = !this.video;
    },
    async sendMessage({ target }) {
      const conversationId = this.$route.params.id;
      const text = target.value;
      if (target.value === '' || /^\s*$/i.test(target.value)) {
        target.value = '';
        target.style.height = '27px';
        return;
      }
      target.value = '';
      target.style.height = '27px';
      const { firstName, lastName, userId, avatar, userInitials } = this.$store.state.permission;
      const user = {
        user: `${firstName} ${lastName}`,
        userId,
        avatar,
        initials: userInitials,
      };
      await this.$store.dispatch('chat/sendText', { conversationId, user, text });
      await this.scrollToEnd();
    },
    async scrollToEnd() {
      const ref = this.$refs.chatView;
      ref.scrollTop = ref.scrollHeight;
      await new Promise(resolve => setTimeout(resolve, 500));
      if ((ref.scrollHeight - ref.scrollTop) > ref.clientHeight + 1) {
        await this.scrollToEnd();
      }
    },
    download(url) {
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.href = url;
      link.click();
    },
  }
};
</script>

<style scoped>
.cons-videos {
  display: flex;
  flex-wrap: wrap;
  flex: auto;
  justify-content: space-between;

  flex: 0 1 calc(100% - 56px);
  overflow: hidden;
}
.cons-videos .co {
  flex: 0 0 100%;
  justify-content: center;
  align-items: center;
}
.cons-videos .co-3 {
  height: 33.333%;
}
.cons-videos .co-2 {
  height: 50%;
}
.cons-videos .co-4 {
  flex: 0 0 100%;
  height: 25%;
}
.cons-videos .co-5,
.cons-videos .co-6 {
  flex: 0 0 50%;
  height: 33.333%;
}
.cons-videos .co-7,
.cons-videos .co-8 {
  flex: 0 0 50%;
  height: 25%;
}
.cons-videos .co-5:last-child {
  flex: 0 0 100%;
}
.image {
  border-radius: 4px;
  overflow: hidden;
}
.chat-message {
  display: flex;
  padding: 0 2rem;
  margin-top: 1rem;
  width: 100%;
}
.chat-message .avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  flex: 0 0 46px;
  position: relative;
}
.chat-message .face-avatar {
  flex: 0 0 46px;
}
.chat-message .avatar > div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-size: cover;
  background-color: rgba(0, 0, 0, .1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
}
.chat-date {
  text-align: center;
  font-weight: 600;
  color: #5e5e5e;
  margin-top: 1rem;
}
.chat-message .content {
  padding-left: 1rem;
  padding-right: 1rem;
}
.chat-message .content .title {
  font-weight: 600;
}
.chat-message .content .text {
  color: #424242;
  white-space: pre-wrap;
  word-break: break-all;
}
.cons {
  display: flex;
  height: 100vh;
  width: 100%;
  padding: 2rem;
}
.cons-card {
  display: flex;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, .1);
  width: 100%;
  flex: auto;
  border-radius: 4px;
  overflow: hidden;
}
.cons-video {
  position: relative;
  background-color: #cecece;
  flex: 0 0 390px;
  width: 390px;
  display: flex;
  flex-direction: column;
}
.chat-viewer {
  overflow: auto;
  padding-bottom: 2rem;
}
.cons-chat {
  display: flex;
  flex: auto;
  flex-direction: column;
  justify-content: space-between;
}
video {
  display: block;
  background-color: black;
  height: calc(50% - 28px);
  width: 100%;
}
.chat-enter {
  min-height: 56px;
  width: 100%;
  display: flex;
  flex-shrink: 0;
}
.chat-enter .chat-input {
  flex: auto;
}
.chat-enter .chat-input .chat-textarea-wrap {
  display: flex;
  align-items: center;
  height: 100%;
}
.chat-enter .chat-input .chat-textarea-wrap textarea {
  position: relative;
  z-index: 2;
  display: block;
  background-color: transparent;
  border: 0;
  width: 100%;
  outline: none;
  resize: none;
}
.chat-enter .chat-attachment {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}
.chat-enter .chat-attachment i {
  font-size: 2rem;
  color: #8d8d8d;
  cursor: pointer;
}
.chat-enter .chat-attachment i:hover {
  color: rgb(93, 153, 231);
}
.chat-title {
  display: flex;
  margin: 0 2rem;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  color: #6b6b6b;
}
.chat-title .time {
  text-align: right;
}
.chat-title .name {
  font-size: 18px;
}
.chat-title .specialty {
  font-size: 14px;
  color: #a0a0a0;
}
.chat-title .avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  flex: 0 0 46px;
  position: relative;
  margin-right: 1rem;
}
.chat-title .info {
  display: flex;
  margin: 0;
}
.chat-title .face-avatar {
  flex: 0 0 46px;
}
.chat-title .avatar > div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-size: cover;
  background-color: rgba(0, 0, 0, .1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
}
.chat-title .prefix {
  font-weight: 400;
  color: rgb(107, 107, 107);
  margin-right: 5px;
}
.chat-title .time {
  font-weight: 300;
  color: #a0a0a0;
}
.chat-viewer {
  flex: auto;
  border-top: 1px solid rgba(0, 0, 0, .08);
  border-bottom: 1px solid rgba(0, 0, 0, .08);
}
.video-bottom {
  background-color: #fff;
  height: 56px;
  border-right: 1px solid rgba(0, 0, 0, .08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  flex: 0 0 56px;
}
.video-bottom button {
  display: flex;
  height: 36px;
  width: 36px;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  outline: 0;
}
.video-bottom button i {
  font-size: 2rem;
  color: #8d8d8d;
  transition: color 150ms ease-in;
}
.video-bottom button:hover i {
  color: rgb(93, 153, 231);
}
.video-bottom button i.red {
  color: rgb(236, 96, 96);
}
.chat-time {
  margin-left: auto;
  align-self: flex-end;
  color: #a5a5a5;
}

.download-icon {
  border-radius: 50%;
  background-color: rgb(80, 175, 253);
  width: 52px;
  height: 52px;
  flex: 0 0 52px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.download-icon i {
  color: #fff;
  font-size: 2rem;
}
.file {
  display: flex;
  align-items: center;
  margin-top: 1rem;
}
.file .info-title {
  font-weight: 600;
  margin-bottom: 0.1rem;
}
.info {
  margin-left: 0.7rem;
}
.info button {
  background-color: transparent;
  color: rgb(52, 163, 253);
  outline: 0;
}
img {
  max-width: 400px;
  max-height: 600px;
  width: 100%;
}
.video-bottom button.chat {
  display: none;
}
.chat-action {
  display: flex;
  padding-left: 1.5rem;
  padding-right: 38px;
}
.voice-chat {
  background-color: transparent;
  display: none;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
  outline: 0;
}
.voice-chat i {
  font-size: 2rem;
  color: #8d8d8d;
}
.voice-chat:hover i {
  color: rgb(93, 153, 231);
}
@media (max-width: 800px)  {
  .voice-chat {
    display: flex;
  }
  .video-bottom button.chat {
    display: block;
  }
  .cons-card {
    position: relative;
  }
  .cons-video {
    flex: 0 0 100%;
    width: 100%;
  }
  .cons-chat {
    position: absolute;
    left: 100%;
    bottom: 0;
    top: 0;
    width: 100%;
    background-color: white;
    transition: left 300ms ease;
  }
  .cons-chat.show {
    left: 0;
  }
}
</style>